export interface PkgContent {
  productCategory: string
  quantity: number
  isSet?: boolean
}
export enum PkgStatus {
  Ready = 'ready',
  NeedId = 'needs_identification',
  Shipped = 'shipped',
}
export enum PkgWarehouse {
  GR = 'GR',
  USA = 'USA',
  UK = 'UK',
  UAE = 'UAE',
}
export enum PkgShippingMethod {
  PickUpPoint = 'pickUpPoint',
  DoorToDoor = 'doorToDoor',
  Test = 'test',
}
export interface PkgReqFields {
  shrinkRequestId?: string
  photoRequestId?: string
  returnRequestId?: string
  uniteRequestId?: string

  isShrinkRequestActive?: boolean
  isPhotoRequestActive?: boolean
  isReturnRequestActive?: boolean
  canCancelReturnRequest?: boolean
  isUniteRequestActive?: boolean

  isShrinkRequestApproved?: boolean
  isForUnite?: boolean
  returnLabel?: string
  photos?: string[]
  photo?: string
  returnLabelFalse?: boolean
}
export interface PkgDimension {
  weight: number
  height: number
  length: number
  width: number
}
export interface UserPkg extends PkgReqFields {
  id: string
  toTrackingNumber: string
  fromTrackingNumber: string
  brand: string
  arrivalDate: string
  dimensions: PkgDimension
  shippingAddress: {
    address: string
    apartmentNumber: string
    city: string
    postalCode: string
  }
  isFlammable: boolean
  isShrinked: boolean
  createdAt: string
  isShipped: boolean
  isPaid: boolean
  contents: PkgContent[]
  readyAt: string
  status: PkgStatus
  warehouse: PkgWarehouse
  shippingMethod: PkgShippingMethod
  valueInUSD: number
  buyingReciptKey: string
  price: number
  costumerIsraeliId?: string
  falseReceiptDate: string
  delayChargePrice?: number
  taxFreeFeeUSD?: number
  delayStatus?: string
  isDraft?: boolean
  delayedPackageId?: string
  shippedAt?: string
}
